<div class="nav-decrease-button-wrapper">
  <span class="nav-decrease-button">Zmniejsz menu</span>
  <!--  TODO: svg check - size="2px" -->
  <wchfs-icon class="icon" size="2px" svgIcon="wchfs:form_arrow_down_ico"></wchfs-icon>
</div>
